import { render } from "./AddPermissions.vue?vue&type=template&id=0250b700&scoped=true"
import script from "./AddPermissions.vue?vue&type=script&lang=js"
export * from "./AddPermissions.vue?vue&type=script&lang=js"

import "./AddPermissions.vue?vue&type=style&index=0&id=0250b700&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0250b700"]])

export default __exports__